import { render } from "./MeusPagamentos.vue?vue&type=template&id=7a11a900"
import script from "./MeusPagamentos.vue?vue&type=script&lang=js"
export * from "./MeusPagamentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__